/**
 * Force HTTPS and collapse doubled slashes on a storage/presigned image URL.
 *
 * The local stack serves `config.js` over http while the portless host forces
 * https, so an http:// image URL is blocked as mixed content and the image
 * goes blank with no console error worth reading.
 *
 * @param url - The image URL as returned by the backend.
 * @returns The URL, over https, without doubled slashes.
 */
export function normalizeImageUrl(url: string): string {
  return url.replace(/^http:\/\//, 'https://').replace(/([^:]\/)\/+/g, '$1');
}
